// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f22f6f280c12db08daff","655":"a3048c21edb35aa94873"}[chunkId] + ".js";
};